function capitalize(text) {
  return text
    .toLowerCase()
    .split(" ")
    .map(s => s.charAt(0).toUpperCase() + s.substring(1))
    .join(" ");
}

export default {
  capitalize
};



// WEBPACK FOOTER //
// ./src/api/helpers/string.js